import React, { useCallback, useEffect, useState } from "react";
import s from "../styles.module.css";
import { useForm } from "react-hook-form";
import SearchSelect from "../../Select/SearchSelect/SearchSelect";
import { filterFields } from "../../../../data/Fields";

const Filter = ({ onSubmit, results, loading, hideAgents, onClear   }) => {


  const { register, watch, setValue, getValues, handleSubmit, reset } = useForm(
    {
      defaultValues: { propertyType: "" },
    }
  );

  const [data, setData] = useState({});
  const [loadingData, setLoadingData] = useState(false);
  const [loadingError, setLoadingError] = useState(null);

  const propertyType = watch("property_type");

  const handlePropertyTypeChange = useCallback(
    (newType) => {
      Object.keys(getValues()).forEach((key) => {
        if (key !== "property_type") {
          setValue(key, "");
        }
      });

      setValue("property_type", newType);
    },
    [getValues, setValue]
  );

  useEffect(() => {
    if (propertyType) {
      handlePropertyTypeChange(propertyType);
    }
  }, [propertyType, handlePropertyTypeChange]);

  const fetchData = async () => {
    setLoadingData(true);
    setLoadingError(null);
    try {
      const results = await Promise.all(
        [...filterFields]
            .filter((field) => field.apiKey  && !field.selectOptions && field.apiKey !== "property_id" && field.apiKey !== "min_price")
          .map(async (field) => {
            let url = "";

            if (field.apiKey === "district_id") {
              url = `${process.env.REACT_APP_API_URL}/api/v1/districts`;
            } else if (field.apiKey === "agents") {
              url = `${process.env.REACT_APP_API_URL}/api/v1/agents`;
            } else {
              url = `${process.env.REACT_APP_API_URL}/api/v1/${field.apiKey}/`;
            }

            const response = await fetch(url);
            if (!response.ok) {
              throw new Error(`Ошибка: ${response.statusText}`);
            }

            let data = await response.json();

            if (field.apiKey === "district_id") {
              data = data.map((region) => ({
                title: region.name,
                districts: region.Districts.map((district) => ({
                  value: district.ID,
                  label: district.name,
                })),
              }));
            }

            return { [field.apiKey]: data || [] };
          })
      );

      const combinedResults = results;
      setData(combinedResults.reduce((acc, item) => ({ ...acc, ...item }), {}));
    } catch (error) {
      console.error("Ошибка при загрузке данных:", error);
      setLoadingError(error.message);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const watchedValues = watch();


  const isAnyFieldFilled = Object.values(watchedValues).some((value) => value);

  const renderField = (field, data) => {

    if (hideAgents && field.apiKey === "agents") {
      return null;
    }

      if (field.name === "land_type" && propertyType !== "Дома и участки") {
          return null;
      }

      if (field.type === "price_range") {
          return (
              <div key={field.name} className={s.priceRangeContainer}>
                  <label className={s.inputLabel}>{field.label}</label>
                  <div className={s.priceInputs}>
                      {field.fields.map((subField) => (
                          <input
                              key={subField.name}
                              type="number"
                              placeholder={subField.placeholder}
                              {...register(subField.name)}
                              className={s.priceInput}
                          />
                      ))}
                  </div>
              </div>
          );
      }

    if (field.type === "select") {
      let options = [];


        if (field.selectOptions) {
            options = field.selectOptions;
        } else if (field.apiKey && data[field.apiKey]) {
        if (Array.isArray(data[field.apiKey])) {
      
          if (field.apiKey === "agents") {
            options = data[field.apiKey].map((item) => ({
              value: item.id,
              label: item.name,
            }));
          }
     
          else if (field.apiKey === "district_id") {
            options = data[field.apiKey];
          }
 
          else {
            options = data[field.apiKey].map((item) => ({
              value: item.name,
              label: item.ID,
            }));
          }
        } else if (data[field.apiKey].data) {
          options = Object.entries(data[field.apiKey].data).map(
            ([key, value]) => ({
              value,
              label: key,
            })
          );
        }
      }

      return (
        <div key={field.name}>
          <SearchSelect
            name={field.name}
            label={field.label}
            placeholder={field.placeholder}
            selected={watch(field.name)}
            {...register(field.name, field.validation)}
            setSelected={(value) =>
              setValue(field.name, value, { shouldValidate: true })
            }
            options={options}
            apiKey={field.apiKey}
          />
        </div>
      );
    } else if (field.type === "search") {
      return (
          <div key={field.name} className={s.inputContainer}>
            <label htmlFor={field.name} className={s.inputLabel}>
              {field.label}
            </label>
            <input
                id={field.name}
                type="text"
                placeholder={field.placeholder}
                {...register(field.name, field.validation)}
                className={s.textInput}
            />
          </div>
      );
    }
  };

  if (loadingData) {
    return (
        <div className="loadingContainer">
          <div className="loader"></div>
        </div>
    );
  }
  if (loadingError) {
    return (
        <div className="errorDataBox">
          <p>{loadingError}</p>
        </div>
    );
  }
  return (
      <form onSubmit={handleSubmit(onSubmit)} className={s.formContainer}>
      <div className={s.box}>
        <h1 className={s.searchTitle}>Поиск</h1>
        <div className={s.row}>
          {filterFields.map((field) => renderField(field, data))}
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <div className="centerLoading">
            {loading ? (
              <div className="loader"></div>
            ) : (
                <div
                    style={{
                      display: "flex",
                      gap: "20px",
                    }}
                >
                  <button
                      type="button"
                      className={s.clearButton}
                      onClick={() => {
                        reset();
                        onClear && onClear();
                      }}
                  >
                    Очистить
                  </button>

                  <button
                      type="submit"
                      disabled={!isAnyFieldFilled}
                      className={s.searchButton}
                      style={
                        !isAnyFieldFilled
                            ? {cursor: "default"}
                            : {cursor: "pointer"}
                      }
                  >
                    Поиск
                  </button>
                </div>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default Filter;
